import axios from '../utils/axios';
import Constants from './types';
import { getSessionId, getPayloadFromError } from 'src/utils';
import store from 'src/store';

export const getAuditEventTypes = () => {
  const sessionId = getSessionId();
  return dispatch => {
    dispatch(getEventTypesRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/audit-events/types',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(getEventTypesSuccess(res.data));
      })
      .catch(err => {
        dispatch(getEventTypesFailure(err));
      });
  };
};

export const loadRecordById = (entityId, recordId) => {
  const sessionId = getSessionId();
  return axios({
    method: 'get',
    url: '/openempi-ws-rest/1.0/records/' + recordId,
    headers: {
      Accept: 'application/json',
      OPENEMPI_SESSION_KEY: sessionId
    },
    params: {
      entityId,
      includeCustom: true
    }
  }).catch(err => {
    getAuditEventsFailure(err);
  });
};

export const getAuditEvents = (entityId, searchValues) => {
  const sessionId = getSessionId();
  const params = buildParams(entityId, searchValues);
  return dispatch => {
    dispatch(getAuditEventsRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/audit-events',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params
    })
      .then(res => {
        dispatch(getAuditEventsSuccess(formatAuditEvents(res.data)));
      })
      .catch(err => {
        dispatch(getAuditEventsFailure(err));
      });
  };
};

const buildParams = (entityId, searchValues) => {
  let params = { entityId };
  if (searchValues.types) {
    const eventTypes = searchValues.types.join();
    params['eventTypes'] = eventTypes;
  }
  if (searchValues.startDate) {
    params['startDate'] = searchValues.startDate.format('YYYYMMDD');
  }
  if (searchValues.endDate) {
    params['endDate'] = searchValues.endDate.format('YYYYMMDD');
  }
  return params;
};

const formatAuditEvents = events => {
  const eventTypes = store.getState().auditEvents.types;
  const users = store.getState().users.users;
  const output = events.map(event => {
    const auditEventType = eventTypes.find(
      type => type.auditEventTypeCd === event.auditEventTypeId
    );
    event['auditEventType'] = auditEventType
      ? auditEventType.auditEventTypeName
      : '';
    let refs = [];
    if (event['refRecordId']) {
      refs.push(event['refRecordId']);
    }
    if (event['altRefRecordId']) {
      refs.push(event['altRefRecordId']);
    }
    event['refs'] = refs;
    const user = users.find(user => user.id === event.userCreatedById);
    if (user) {
      event['userCreatedBy'] = user.username;
    }
    return event;
  });
  return output;
};

export const clearAuditEventsError = () => {
  return {
    type: Constants.AUDIT_EVENTS_CLEAR_ERROR
  };
};

const getEventTypesRequest = () => {
  return {
    type: Constants.AUDIT_EVENTTYPES_GET_REQUEST
  };
};

const getEventTypesSuccess = data => {
  return {
    type: Constants.AUDIT_EVENTTYPES_GET_SUCCESS,
    payload: data
  };
};

const getEventTypesFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.AUDIT_EVENTTYPES_GET_FAILURE,
    payload
  };
};

const getAuditEventsRequest = () => {
  return {
    type: Constants.AUDIT_EVENTS_GET_REQUEST
  };
};

const getAuditEventsSuccess = data => {
  return {
    type: Constants.AUDIT_EVENTS_GET_SUCCESS,
    payload: data
  };
};

const getAuditEventsFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.AUDIT_EVENTS_GET_FAILURE,
    payload
  };
};
